import { IAction } from '~/src/store';

import { ESpeedBonusActions } from './constants';

interface IRoutersPrice {
    id: number,
    duration: number,
    isTestDrive?: 0 | 1,
}

export const setRoutersPrice = (priceInfo: IRoutersPrice): IAction<ESpeedBonusActions.setRoutersPrice, IRoutersPrice> => ({
    type: ESpeedBonusActions.setRoutersPrice,
    payload: priceInfo,
});
